import React from 'react';
import mainscreen from '../Image/mainscreen.png';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck,faToolbox,faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import '../Css/HomeScreenFooter.css';


function HomeScreenFooter() {
  return (
    <div className="MainScreenFooter-content">
      「家居維修不再是煩惱 ! 維修王致力於為香港市民打造最值得信賴的師傅配對平台。我們的服務範疇廣泛，涵蓋水電工程、冷氣清洗維修、油漆翻新、鋁窗檢驗及全屋裝修。所有加盟師傅均經過身份認證，確保服務品質。此外，我們更開辦家居維修課程，協助有意入行的人士掌握水電技能與創業教學。不論是想搵師傅還是學維修，維修王都是你的首選。」
    </div>
  )
}

export default HomeScreenFooter
